export default class Utils {
  static currencyFormat(value: number): string {
    return new Intl.NumberFormat("en-US").format(value);
  }
}
